import { create } from 'zustand';

export const useStrategyDeskStore = create((set) => ({
    viewMode: 'strategy',
    modeFilter: 'all',
    selectedInstanceId: null,
    drawerOpen: false,

    setViewMode: (viewMode) => set({ viewMode }),
    setModeFilter: (modeFilter) => set({ modeFilter }),
    selectInstance: (instanceId) => set({ selectedInstanceId: instanceId, drawerOpen: true }),
    clearSelection: () => set({ selectedInstanceId: null, drawerOpen: false }),
    closeDrawer: () => set({ drawerOpen: false }),
}));
